import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CModal } from "@/components";
import styles from "./index.module.less";
import { Button, Form, Input, message } from "antd";
import { useEffect, useState } from "react";
import { renameResume } from "@/services/attachmentManager";
import { parseFileName } from "@/utils/file";
import { useResumeFile } from "@/store/useResumeFile";
import { useLocale } from "@/hooks/useLocale";
import { withErrorBoundary } from "../ErrorBoundary/hoc";
import { dispatchSensitive, removeDispatchSensitive } from "@bossvn/tools";
const RenameModal = withErrorBoundary(({ isRenameModalOpen, setIsRenameModalOpen, currentResume, locale }) => {
    const [renameForm] = Form.useForm(); // 表单
    const [loading, setLoading] = useState(false); // 提交loading
    const getResumeList = useResumeFile((state) => state.getResumeList);
    const { t } = useLocale("attachmentManager", locale);
    // 敏感词检测
    useEffect(() => {
        const id = Symbol("RenameModal");
        dispatchSensitive("RenameModal", {
            form: renameForm,
            id,
        });
        return () => {
            removeDispatchSensitive(id);
        };
    }, []);
    // 简历名称赋值
    useEffect(() => {
        if (currentResume && isRenameModalOpen) {
            const { name } = parseFileName(currentResume?.files?.[0]?.fileName);
            renameForm.setFieldsValue({
                fileName: name,
            });
        }
        return () => {
            renameForm.resetFields();
        };
    }, [currentResume, isRenameModalOpen]);
    // 编辑简历名称
    const handleRename = async () => {
        try {
            setLoading(true);
            const { fileName } = await renameForm.validateFields(); // 简历名称
            const { ext } = parseFileName(currentResume?.files?.[0]?.fileName); // 简历名称后缀
            const response = await renameResume({ fileGroupId: currentResume?.fileGroupId || '', fileName: fileName.replace(" ", "") + "." + ext });
            if (response.code === 1001053)
                return;
            if (response.code === 0) {
                message.success(t('editSucceed'));
                setIsRenameModalOpen(false);
                getResumeList();
                return;
            }
            message.error(t('editFailed'));
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx(CModal, { open: isRenameModalOpen, width: 501, closable: false, centered: true, title: _jsx("div", { className: styles.renameModal_title, children: t('changeCVName') }), showCancel: false, footer: _jsxs("div", { className: styles.renameModal_footer, children: [_jsx(Button, { className: styles.renameModal_footer_ok, type: "primary", loading: loading, onClick: handleRename, children: t('confirm') }), _jsx("div", { className: styles.renameModal_footer_cancel, onClick: () => setIsRenameModalOpen(false), children: t('cancel') })] }), children: _jsx("div", { className: styles.renameModal, children: _jsx(Form, { form: renameForm, children: _jsx(Form.Item, { name: "fileName", rules: [
                        {
                            required: true,
                            message: t('pleaseInputName'),
                            validator: () => {
                                if (renameForm.getFieldValue("fileName").toString().trim() === "") {
                                    return Promise.reject(new Error(t('pleaseInputName')));
                                }
                                else {
                                    return Promise.resolve();
                                }
                            },
                        },
                    ], children: _jsx(Input, { style: { height: '32px', padding: '0px 12px' }, placeholder: t('pleaseInputName'), maxLength: 55, showCount: true }) }) }) }) }));
});
export default RenameModal;
RenameModal.displayName = "RenameModal";
